// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pisqwjIN203xzYifjvDe3A\\=\\={display:flex}", "",{"version":3,"sources":["webpack://./resources/js/components/AppHeader/BottomHeader/ProfileButton/styles.module.scss"],"names":[],"mappings":"AAAA,4BACI,YACJ","sourcesContent":[".account_dropdown {\n    display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"account_dropdown": "pisqwjIN203xzYifjvDe3A=="
};
export default ___CSS_LOADER_EXPORT___;
